import Icon from '../components/Icon.vue'

Icon.register({
  expand: {
    width: 448,
    height: 512,
    paths: [
      {
        d: 'M0 180V56C0 42.7 10.7 32 24 32H148C154.6 32 160 37.4 160 44V84C160 90.6 154.6 96 148 96H64V180C64 186.6 58.6 192 52 192H12C5.4 192 0 186.6 0 180zM288 44V84C288 90.6 293.4 96 300 96H384V180C384 186.6 389.4 192 396 192H436C442.6 192 448 186.6 448 180V56C448 42.7 437.3 32 424 32H300C293.4 32 288 37.4 288 44zM436 320H396C389.4 320 384 325.4 384 332V416H300C293.4 416 288 421.4 288 428V468C288 474.6 293.4 480 300 480H424C437.3 480 448 469.3 448 456V332C448 325.4 442.6 320 436 320zM160 468V428C160 421.4 154.6 416 148 416H64V332C64 325.4 58.6 320 52 320H12C5.4 320 0 325.4 0 332V456C0 469.3 10.7 480 24 480H148C154.6 480 160 474.6 160 468z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/expand.js
// module id = Gzhx
// module chunks = 144